import React from "react";
//#region types
import { FileGridListItem } from "models/utilTypes/fileUtilsTypes";
import { FileGridContainerProps } from "models/propTypes/fileUploaderPropTypes";
//#endregion
//#region compnents
import FilesGrid from "../../../lists/filesGrid";
//#endregion
//#region helpers
import { FileHelper } from "utils/helpers";
//#endregion

const FilesGridContainer: React.FC<FileGridContainerProps> = (props) => {
  const fileGridItems = React.useMemo(() => {
    let items: FileGridListItem[] = [];

    if (props.files !== null && props.files.length > 0) {
      items = props.files.map((file, index) => ({
        id: file.id !== undefined ? file.id : 0,
        name: file.fileName,
        sizeInBytes: file.fileSize ?? file.data?.length,
        fileMeta: {
          content: file.data,
          contentType: FileHelper.normalizeContentType(file.fileName, file.contentType),
        },
        handleClose: () => {
          props.handleClose(index);
        },
        hideRemove: props.readonly || file.locked,
        locked: file.locked,
        lockedText: file.locked ? file.lockedText : undefined,
      }));
    }

    items = items.concat(
      props.remainingFiles.map((item) => ({
        id: item.id,
        name: item.name,
        sizeInBytes: item.sizeInBytes,
        fileMeta: null,
        handleClose: () => {
          props.onStopReading(item.id);
        },
        progressBar: true,
        progress: item.progress,
      }))
    );

    return items;
  }, [props.files, props.remainingFiles, props.readonly]);

  return <FilesGrid fileGridItems={fileGridItems} onTileClick={props.onTileClick}></FilesGrid>;
};

export default FilesGridContainer;
